export const handlePaginationList = (page, rowsPerPage, list) => {
    let startIndex = page * rowsPerPage;
    let lastIndex = startIndex + rowsPerPage;
    let paginatedList = list?.slice(startIndex, lastIndex);
    return paginatedList;
}

export const updateTableSortConfigObject = (configObject, isSortByAsc, currentSortBy, nextSortBy) => {
    let newHeadingArray = configObject.headings.map(item => {
        if (item.headingLabel === nextSortBy && nextSortBy !== "Actions") {
            item.icon = isSortByAsc ? "sort-alpha-down" : "sort-alpha-up";
        } else {
        //if (nextSortBy !== currentSortBy && item.headingLabel === currentSortBy && nextSortBy !== "Actions") {
            item.icon = "";
        }
        return item;
    });
    delete configObject.headings
    configObject.headings = newHeadingArray;
    return configObject;
}

const episodeNumberSort = (a, b, isSortByAsc) => {
    const epA = Number(String(a['episode_number'] || '').replace(/\D/g, ''));
    const epB = Number(String(b['episode_number'] || '').replace(/\D/g, ''));
    return isSortByAsc ? epA - epB : epB - epA;
};

export const showSeasonTableSortList = (type, typeField, list, isSortByAsc) => {
     let sortedList;
     switch (type) {
     case "Name":
         sortedList = list?.sort((a, b) => {
        const aValue = a[typeField];
        const bValue = b[typeField];
        if (aValue === null && bValue !== null) return isSortByAsc ? -1 : 1;
        if (bValue === null && aValue !== null) return isSortByAsc ? 1 : -1;
        if (aValue === null && bValue === null) return episodeNumberSort(a, b, isSortByAsc);
        const aName = aValue.toString().split(' ').join('').toLowerCase();
        const bName = bValue.toString().split(' ').join('').toLowerCase();
        let result;
        if (isSortByAsc) {
            result = aName > bName ? 1 : aName < bName ? -1 : 0;
        } else {
            result = bName > aName ? 1 : bName < aName ? -1 : 0;
        }
        return result !== 0 ? result : episodeNumberSort(a, b, isSortByAsc);
       });
       break;
    case "Date":
         sortedList = list?.sort((a, b) => {
         const rawA = a[typeField];
         const rawB = b[typeField];
       const isNullA = rawA == null || rawA === 'None';
        const isNullB = rawB == null || rawB === 'None';
         if (isNullA && !isNullB) return isSortByAsc ? -1 : 1;
         if (!isNullA && isNullB) return isSortByAsc ? 1 : -1;
         if (isNullA && isNullB) return episodeNumberSort(a, b, isSortByAsc);
         const parsedDateA = new Date(rawA);
         const parsedDateB = new Date(rawB);
         const result = isSortByAsc ? parsedDateA - parsedDateB : parsedDateB - parsedDateA;
         return result !== 0 ? result : episodeNumberSort(a, b, isSortByAsc);
        });
        break;
     
        case "Number":
         sortedList = list?.sort((a, b) => {
             const numA = Number(String(a[typeField] || '').replace(/\D/g, ''));
             const numB = Number(String(b[typeField] || '').replace(/\D/g, ''));
             const result = isSortByAsc ? numA - numB : numB - numA;
             return result !== 0 ? result : episodeNumberSort(a, b, isSortByAsc);
         });
         break;
         case "Boolean":
          sortedList = list?.sort((a, b) => {
             const valA = Number(Boolean(a[typeField]));
             const valB = Number(Boolean(b[typeField]));
             const result = isSortByAsc ? valA - valB : valB - valA;
             return result !== 0 ? result : episodeNumberSort(a, b, isSortByAsc);
         });
         break;
        }
        return sortedList;
    }   
export const tableSortList = (type, typeField, list, isSortByAsc) => {
    let sortedList;
    switch (type) {
        case "Name":
           if (isSortByAsc) {
                sortedList = list?.sort((a, b) => (a[typeField]?.toString().split(' ').join('').toLowerCase() > b[typeField]?.toString().split(' ').join('').toLowerCase()) ? 1 : -1);
            } else {
                sortedList = list?.sort((a, b) => (b[typeField]?.toString().split(' ').join('').toLowerCase() > a[typeField]?.toString().split(' ').join('').toLowerCase()) ? 1 : -1);
           }
            break;

        case "Date":
            if (isSortByAsc) {
                sortedList = list?.sort((a, b) => (Date.parse(a[typeField]?.toString().trim()) > Date.parse(b[typeField]?.toString().trim())) ? 1 : -1);
            } else {
                sortedList = list?.sort((a, b) => (Date.parse(b[typeField]?.toString().trim()) > Date.parse(a[typeField]?.toString().trim())) ? 1 : -1);
            }
            break;
        case "Number":
            if (isSortByAsc) {
                sortedList = list?.sort((a, b) => {
                    const numA = (a[typeField] || '').replace(/\D/g, '');
                    const numB = (b[typeField] || '').replace(/\D/g, '');
                    return numA.localeCompare(numB);
                });
            } else {
                sortedList = list?.sort((a, b) => {
                    const numA = (a[typeField] || '').replace(/\D/g, '');
                    const numB = (b[typeField] || '').replace(/\D/g, '');
                    return numB.localeCompare(numA);
                });
            }
            break; 
    }
    return sortedList;
}


export const applyFilterTable = (config, data, filterValues, filtersNone) => {
    var finalList = [];
    var finalResult = [];
    var primaryKey = config.primaryKey;
    if (!filtersNone) {

        filterValues.map((filter) => {
            var keyValue = filter.split(":");
            var name = keyValue[0].trim();
            var value = keyValue[1].trim().toLowerCase();

            var index = -1; // Object.keys(config?.headings).indexOf((item) => config?.headings[item].headingLabel == name);

            Object.keys(config?.headings).map((item) => {
                console.log(config?.headings[item])
                if (config?.headings[item].headingLabel == name) {
                    index = item;
                    return;
                }
            });

            var nodeName = config?.dataNodes[index];
            var filteredList = data?.filter((item) => item[nodeName] != null ? item[nodeName].toString().toLowerCase().indexOf(value) > -1 : false);
            finalResult = finalResult.concat(filteredList?.filter((list) => !finalResult.find(p => p[primaryKey] == list[primaryKey])));

        });
    }
    else {
        finalResult = data;
    }
    //this.setState({filteredList : finalResult});    
    return finalResult;
}